<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'ORDERS.TAX_DEDUCTION_LABEL' | translate }}</h3>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x2 sp-order-details-general-tax-deduction__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info
      [label]="'ORDERS.TAX_DEDUCTION_LABEL'"
      [content]="order?.tax_deduction ? ('GENERAL.YES_LABEL' | translate) : ('GENERAL.NO_LABEL' | translate)"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.APPROVED_LABEL'"
      [content]="order?.ready_for_liquidation_at ? ('GENERAL.YES_LABEL' | translate) : ('GENERAL.NO_LABEL' | translate)"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'COMPANIES.TAX_DEDUCTION_TYPE_LABEL'"
      [content]="getDeductionTypeLabel()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.TAX_DEDUCTION_INVOICE_DATE_LABEL'"
      [content]="(order?.tax_deduction?.tax_deduction_invoice_date | date : 'shortDate') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.TAX_DEDUCTION_INVOICE_NUMBER_LABEL'"
      [content]="order?.tax_deduction?.tax_deduction_invoice_number || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
</div>
